import { useUIStore } from '../../stores/uiStore'
import ChatWindow from './ChatWindow'

export default function ChatWidget() {
  const { isChatOpen, toggleChat } = useUIStore()

  return (
    <>
      {/* Chat Window */}
      {isChatOpen && <ChatWindow />}

      {/* Floating Action Button */}
      <button
        onClick={toggleChat}
        className="fixed bottom-6 right-6 w-14 h-14 bg-primary-600 hover:bg-primary-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-200 hover:scale-105 z-40"
        aria-label={isChatOpen ? 'Close chat' : 'Open support chat'}
      >
        <i className={`fas ${isChatOpen ? 'fa-times' : 'fa-headset'} text-xl`}></i>
      </button>
    </>
  )
}
